import React from "react";

const Logo = ({ light = true, className = "h-10 w-10" }) => (
  <img
    src="/logo-emblem.png"
    alt="AWEN — Bienestar emocional integral"
    className={`${className} rounded-full object-cover ${light ? "" : ""}`}
    data-testid="awen-logo"
  />
);

export default Logo;
